<tec-modal
    [isVisible]="true"
    [title]="'USERS.FORM.EDIT' | translate"
    [tagImage]="modalTagImage"
    [buttonPrimaryLabel]="primaryButtonLabel"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    (closeEvent)="closeModal($event)"
>
    <ng-container body [formGroup]="form">
        @if (errorMsg) {
        <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        }

        <tec-info-group [label]="'USERS.FORM.USER' | translate">
            <span>{{ detail?.name }}</span>
        </tec-info-group>

        <div class="grid grid-i2">
            <tec-form-group
                [label]="((isSupervisorRoleSelected ? 'USERS.FORM.COMPANIES' : 'USERS.FORM.COMPANY') | translate) + '*'"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('companies_uuid'))"
            >
                @if (isSupervisorRoleSelected) {
                    <tec-select
                        formControlName="companies_uuid"
                        [options]="masterService.companies"
                        [hasError]="reactiveFormService.hasError(form.get('companies_uuid'))"
                        [multiple]="true"
                        [placeholder]="'USERS.FORM.COMPANIES_PLACEHOLDER' | translate"
                    />
                } @else {
                    <tec-select
                        formControlName="companies_uuid"
                        [options]="masterService.companies"
                        [hasError]="reactiveFormService.hasError(form.get('companies_uuid'))"
                        [multiple]="false"
                        [placeholder]="'USERS.FORM.COMPANY_PLACEHOLDER' | translate"
                    />
                }
            </tec-form-group>
        </div>

        <!-- ROLE -->
        <tec-form-group
            [label]="('USERS.FORM.ROLE' | translate) + '*'"
            [errorMsg]="reactiveFormService.hasMsgError(form.get('role_uuid'))"
        >
            <tec-toggle
                formControlName="role_uuid"
                [options]="roles"
                [multiple]="false"
                [requireSelection]="true"
            />
        </tec-form-group>

        <tec-tile styling="default">
            {{ getRoleDescription() }}
        </tec-tile>

        @if (canEditCompanies) {
            <div class="email-alert">
                <tec-alert
                    type="message"
                    status="default"
                    icon="icon-info"
                    [msg]="'USERS.FORM.TECALIS_ACCOUNT_HINT' | translate"
                    hiddenCloseButton
                />
            </div>
        }
    </ng-container>
</tec-modal>
